import { FormikValues } from 'formik';
import FieldWrapper from '../../../components/formInputs/FieldWrapper';
import { useTranslation } from 'react-i18next';
import { customStyles } from '../../../utils/SelectStyles';
import Checkbox from '../../../components/formInputs/Checkbox';
import { useEffect, useState } from 'react';

interface IProps {
  formik: FormikValues;
  fieldIndex: number;
  entityIndex: number;
}

const validationDataCheckBoxes = [
  { name: 'required', id: '1', label: 'required', value: 'required' },
  {
    name: 'numeric',
    id: '2',
    label: 'numeric',
    value: 'numeric'
  },
  {
    name: 'email',
    id: '3',
    label: 'email',
    value: 'email'
  },

  {
    name: 'unique',
    id: '4',
    label: 'unique',
    value: 'unique'
  }
  ,
  {
    name: 'file',
    id: '5',
    label: 'file',
    value: 'file'
  },
  {
    name: 'image',
    id: '6',
    label: 'image',
    value: 'image'
  },
  {
    name: 'gallery',
    id: '7',
    label: 'gallery',
    value: 'gallery'
  }
];
const FieldInputs = ({ formik, fieldIndex, entityIndex }: IProps) => {
  const { t } = useTranslation();
  const [defaultType, setDefaultType] = useState<any>();

  useEffect(() => {
    if (formik?.values?.entities?.[entityIndex]?.fields?.[fieldIndex]?.type) {
      setDefaultType({ label: formik?.values?.entities?.[entityIndex]?.fields?.[fieldIndex]?.type, value: formik?.values?.entities?.[entityIndex]?.fields?.[fieldIndex]?.type });
    }
  }, [formik]);

  const getValidationValue = (validationArray: string[], key: string) => {
    if (Array.isArray(validationArray)) {
      const matchedItem = validationArray.find((item) => typeof item === 'string' && item.trim().startsWith(`${key}:`));
      if (matchedItem) {
        const value = matchedItem.split(':')[1];
        return value !== undefined ? value : '';
      }
    }
    return '';
  };

  const [localMinValue, setLocalMinValue] = useState<string>(
    getValidationValue(formik.values.entities[entityIndex].fields[fieldIndex]?.validation, 'min') || ''
  );

  const [localMaxValue, setLocalMaxValue] = useState<string>(
    getValidationValue(formik.values.entities[entityIndex].fields[fieldIndex]?.validation, 'max') || ''
  );

  // Sync local state if Formik value changes externally
  useEffect(() => {
    const formikMinValue = getValidationValue(formik.values.entities[entityIndex].fields[fieldIndex]?.validation, 'min') || '';
    if (formikMinValue !== localMinValue) {
      setLocalMinValue(formikMinValue);
    }

    const formikMaxValue = getValidationValue(formik.values.entities[entityIndex].fields[fieldIndex]?.validation, 'max') || '';
    if (formikMaxValue !== localMaxValue) {
      setLocalMaxValue(formikMaxValue);
    }
  }, [formik.values.entities[entityIndex].fields[fieldIndex]?.validation]);

  const updateFieldType = (
    formik: any,
    entityIndex: number,
    fieldIndex: number,
    newType: string,
    validationRules: Record<string, string[]>
  ) => {
    const validationPath = `entities[${entityIndex}].fields[${fieldIndex}].validation`;
    const typePath = `entities[${entityIndex}].fields[${fieldIndex}].type`;

    const existingValidation = formik.values.entities[entityIndex].fields[fieldIndex].validation;
    const currentValidation = Array.isArray(existingValidation) ? existingValidation : [];

    // Get required validations for this new type
    const requiredValidations = validationRules[newType] || [];

    // Remove validations for types not matching the newType
    const otherTypes = Object.keys(validationRules).filter(type => type !== newType);
    const cleanedValidation = currentValidation.filter(
      (v: string) => !otherTypes.some(type => validationRules[type]?.includes(v))
    );

    // Merge with required validations for newType
    const finalValidation = Array.from(new Set([...cleanedValidation, ...requiredValidations]));

    // Update Formik values
    formik.setFieldValue(typePath, newType);
    formik.setFieldValue(validationPath, finalValidation);
  };



  return (
    <div className="fields-container">
      <div className="inputs_group">
        <FieldWrapper
          title={t('name')}
          inputName={`entities[${entityIndex}].fields[${fieldIndex}].name`}
          inputPlaceholder={`${t('ex')} ${t('uploadingDocuments')}`}
          inputError={formik?.errors?.entities?.[entityIndex]?.fields?.[fieldIndex]?.name as string}
          inputTouched={formik?.touched?.entities?.[entityIndex]?.fields?.[fieldIndex]?.name as boolean}
          input
          customPadding
        />

        <FieldWrapper
          customPadding
          title={t('type')}
          inputName={`entities[${entityIndex}].fields[${fieldIndex}].type`}
          inputError={formik?.errors?.entities?.[entityIndex]?.fields?.[fieldIndex]?.type as string}
          inputTouched={formik?.touched?.entities?.[entityIndex]?.fields?.[fieldIndex]?.type as boolean}
          inputPlaceholder={t('selectType')}
          options={[
            { label: t('text'), value: 'text' },
            { label: t('file'), value: 'file' },
            { label: t('number'), value: 'number' },
            { label: t('image'), value: 'image' },
            { label: t('gallery'), value: 'gallery' },
          ]}
          // TODO Remove That Part After Testing
          // onChange={(e: any) => {
          //   const validationPath = `entities[${entityIndex}].fields[${fieldIndex}].validation`;
          //   const typePath = `entities[${entityIndex}].fields[${fieldIndex}].type`;

          //   // Fallback to array if not already an array
          //   const existingValidation = formik.values.entities[entityIndex].fields[fieldIndex].validation;
          //   const currentValidation = Array.isArray(existingValidation) ? existingValidation : [];

          //   if (e?.value === 'file') {
          //     formik.setFieldValue(typePath, e.value);

          //     if (!currentValidation.includes('file')) {
          //       const newValidation = [...currentValidation, 'file'];
          //       formik.setFieldValue(validationPath, newValidation);
          //     }
          //   } else if (e?.value === 'text') {
          //     const newValidation = currentValidation.filter((item: string) => item !== 'file');
          //     formik.setFieldValue(validationPath, newValidation);
          //     formik.setFieldValue(typePath, e.value);
          //   }
          // }}
          onChange={(e: any) => {
            const type = e?.value;
            updateFieldType(formik, entityIndex, fieldIndex, type, {
              file: ['file', 'required'],
              text: [],
              number: ['numeric', 'required'],
              image: ['image', 'required'],
              gallery: ['gallery', 'required']
              // Add more types here easily
            });
          }}


          selectStyle={customStyles}
          select
          defaultValue={defaultType}
          key={defaultType?.value}
        />
      </div>
      <div className="inputs_group">
        <FieldWrapper
          title={t('labelEn')}
          inputName={`entities[${entityIndex}].fields[${fieldIndex}].label[en]`}
          inputPlaceholder={`${t('ex')} input 1`}
          inputError={formik?.errors?.entities?.[entityIndex]?.fields?.[fieldIndex]?.label?.en as string}
          inputTouched={formik?.touched?.entities?.[entityIndex]?.fields?.[fieldIndex]?.label?.en as boolean}
          input
          customPadding
        />
        <FieldWrapper
          title={t('labelAr')}
          inputName={`entities[${entityIndex}].fields[${fieldIndex}].label[ar]`}
          inputPlaceholder={`${t('ex')} الخانه الاوله`}
          inputError={formik?.errors?.entities?.[entityIndex]?.fields?.[fieldIndex]?.label?.ar as string}
          inputTouched={formik?.touched?.entities?.[entityIndex]?.fields?.[fieldIndex]?.label?.ar as boolean}
          input
          customPadding
        />
      </div>
      <div className="inputs_group">
        <div className="inputs_group">
          <FieldWrapper title={t('validation')}>
            <div className="checkboxes_wrapper">
              {validationDataCheckBoxes?.map((item: any, i: number) => (
                <Checkbox
                  name={`entities[${entityIndex}].fields[${fieldIndex}].validation`}
                  key={i}
                  item={item}
                  value={formik?.values?.entities?.[entityIndex]?.fields?.[fieldIndex]?.validation?.includes(item.value)}
                  checked={formik?.values?.entities?.[entityIndex]?.fields?.[fieldIndex]?.validation}
                  formik={formik}
                  useCustomLogic
                />

              ))}

            </div>
          </FieldWrapper>
        </div>
        {
          <div className="inputs_group">
            <FieldWrapper
              title={t('minimumSize')}
              inputName=""
              inputPlaceholder={t('minimumSize')}
              inputError={formik.errors.entities?.[entityIndex]?.fields?.[fieldIndex]?.validation as string}
              inputTouched={formik.touched.entities?.[entityIndex]?.fields?.[fieldIndex]?.validation as boolean}
              value={formik?.values?.entities[entityIndex]?.fields[fieldIndex]?.type === 'file' ? localMinValue : ''}
              onChangeForcontrolled={(e) => {
                const newValue = (e.target as HTMLInputElement).value;
                setLocalMinValue(newValue); // Local state updates immediately

                const validationArray = [...formik.values.entities[entityIndex].fields[fieldIndex].validation];
                const filtered = validationArray.filter(item => !(typeof item === 'string' && item.startsWith('min:')));

                if (newValue !== '') {
                  filtered.push(`min:${newValue}`);
                }

                formik.setFieldValue(`entities[${entityIndex}].fields[${fieldIndex}].validation`, filtered);
              }}
              controlledInput
              customPadding
              type="number"
              disabled={!['file', 'image','gallery'].includes(formik?.values?.entities[entityIndex]?.fields[fieldIndex]?.type)}
            />

            <FieldWrapper
              title={t('maximumSize')}
              inputName=""
              inputPlaceholder={t('maximumSize')}
              inputError={formik.errors.entities?.[entityIndex]?.fields?.[fieldIndex]?.validation as string}
              inputTouched={formik.touched.entities?.[entityIndex]?.fields?.[fieldIndex]?.validation as boolean}
              value={formik?.values?.entities[entityIndex]?.fields[fieldIndex]?.type === 'file' ? localMaxValue : ''}
              onChangeForcontrolled={(e) => {
                const newValue = (e.target as HTMLInputElement).value;
                setLocalMaxValue(newValue);

                const validationArray = [...formik.values.entities[entityIndex].fields[fieldIndex].validation];
                const filtered = validationArray.filter(item => !(typeof item === 'string' && item.startsWith('max:')));

                if (newValue !== '') {
                  filtered.push(`max:${newValue}`);
                }

                formik.setFieldValue(`entities[${entityIndex}].fields[${fieldIndex}].validation`, filtered);
              }}
              controlledInput
              customPadding
              type="number"
              disabled={!['file', 'image','gallery'].includes(formik?.values?.entities[entityIndex]?.fields[fieldIndex]?.type)}
            />
          </div>
        }
      </div>
    </div>
  );
};

export default FieldInputs;
